angular.module('trainerWebApp.main').controller('MainCtrl', ['$scope', '$rootScope', '$location', '$timeout', 'flexAngularProxy', '$window', 'refreshSession', 'trackingService', 'navigationHelper', function ($scope, $rootScope, $location, $timeout, flexAngularProxy, $window, refreshSession, trackingService, navigationHelper) {
  $scope.page = {};
  $rootScope.newLocation = {};
  $rootScope.mfConfig = mfConfig;
  $scope.loading = false;

  var needPlaceHolderSupport = BrowserDetect.browser == 'Explorer' && BrowserDetect.version < 10;
  var placeHolderTimeout = 0;

  var idleTimeout = 0;

  $rootScope.$on("$locationChangeStart", function(event, newUrl, oldUrl){
    if (mfConfig.useGroupRestrictions && newUrl.indexOf("/ManageGroups/CreateGroup") > -1){
      event.preventDefault();
    }
    var breadcrumbClicked = navigationHelper.getBreadcrumbClicked(true);
    if (!breadcrumbClicked
      && /#\/TMS\/Customize_Settings\/[\d]+\/customCertificate/g.test(oldUrl)
      && /#\/TMS\/Customize_Settings\/[\d]+$/g.test(newUrl)){
      MF.setOpenFlexPopup();
    }
  });

  $rootScope.$on("$showLoadingSpinner", function (event, loading) {
    $scope.loading = loading;
  });

  $rootScope.$on("$routeChangeStart", function (event, next, previous) {
    resetIdleTimer();
    clearTimeout(placeHolderTimeout);

    if(previous && previous.flex && !next.flex) {
      refreshSession.refresh();
    }

    if (next.flex) {
      return;
    } else {
      $('#appWrapper').removeClass('removedFromLayout');
      $('#flexWrapper').addClass('hideOffscreen');
    }

    $scope.loading = true;
    $scope.active = "progress-striped active progress-warning";
  });


  $rootScope.$on("$routeChangeSuccess", function (event, next, previous) {
    $scope.page.header = next.header === undefined ? 'pages/header/header.html' : next.header;  //Compare to undefined explicitly to preserve false
    $scope.page.footer = next.footer === undefined ? 'pages/footer/footer.html' : next.footer;  //Compare to undefined explicitly to preserve false

    $('body').css('background-color', next.pageColor || '#fff');      //Is there a cleaner way to set the background for different routes?

    initPlaceholders();

    if (next.flex) {
      MF.loadAppSwf();
      MF.changeUrlHash();
      setTimeout(function () {
        $('#flexWrapper').css('top', '0px'); // Evergage fix to keep Flex app at 100% window height (necessary because they add top styling to shift the page down for HTML)

        $('#flexWrapper').removeClass('hideOffscreen');
      }, 50);
    } else {
      MF.changeUrlHash('/TMS/blank');
    }
    $('#appWrapper').toggleClass('removedFromLayout', !!next.flex);

    $rootScope.newLocation.path = $location.path();
    $rootScope.newLocation.search = $location.search();

    trackingService.trackPageView($rootScope.newLocation.path);

    $scope.loading = false;
    $scope.active = "progress-success";

  });

  $rootScope.$on("$routeChangeError", function (event, current, previous, rejection) {
    $scope.loading = false;

    if(rejection && rejection.redirectUrl) {
      // replace for history
      $location.url(rejection.redirectUrl).replace();
      return;
    }

    // if we don't have a rejection let the controller handle it
    // lets just make sure to stay where we are
    if (rejection === false) {
      $rootScope.newLocation.next = {};
      $rootScope.newLocation.next.path = $location.path();
      $rootScope.newLocation.next.search = $location.search();
      $location.path($rootScope.newLocation.path).search($rootScope.newLocation.search);
      return;
    }

    $scope.active = "";

    $window.location.href = '/500.html';
  });

  $rootScope.$on("initPlaceholders", initPlaceholders);

  function initPlaceholders() {
    // only need placeholder support for IE8 and IE9
    if (needPlaceHolderSupport) {
      placeHolderTimeout = setTimeout(function () {
        // ignore input that are select2 because placeholder is built in
        $('input[placeholder]:not([ui-select2])').placeholder();
        $('textarea[placeholder]').placeholder();
      }, 500);
    }
  }


  if ($window.addEventListener) {  // all browsers except IE before version 9
    $window.addEventListener("beforeunload", onBeforeUnloadHandler, false);
  }
  else {
    if ($window.attachEvent) {   // IE before version 9
      $window.attachEvent("onbeforeunload", onBeforeUnloadHandler);
    }
  }

  // the OnBeforeUnLoad method will only be called in Google Chrome and Safari
  function onBeforeUnloadHandler(event) {
    if(!$window.MF || !$window.MF.flexOnBeforeUnload) return;
    var flexResult = $window.MF.flexOnBeforeUnload();
    if (flexResult) {
      if (event)
        event.returnValue = message;
      return flexResult;
    }
    var customWarnings = [];
    var e = $rootScope.$broadcast("appOnBeforeUnload", customWarnings);
    if (e.defaultPrevented) {
      var message = customWarnings.length > 0 ? customWarnings[0] : "Refreshing or leaving this page will cause you to lose any unsaved data.";
      if (event)
        event.returnValue = message;
      return message;
    }
  }

  function resetIdleTimer() {
    if(mfConfig.sessionInactivityExpirationMinutes) {
      $timeout.cancel(idleTimeout);
      idleTimeout = $timeout(function () {
        window.location = 'https://' + window.location.host + '/logout.aspx?userId=' + mfConfig.userId +
          '&redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.hash);
      }, mfConfig.sessionInactivityExpirationMinutes * 60000);
    }
  }

  flexAngularProxy.setup();
}]);
